export default __webpack_public_path__ + "static/media/widgetMinimap.4e5e72ad.svg";